<div [hidden]="!isLoading" id="spinner-container" >
  <!-- <h6> -->
    <!-- <i class="fa fa-spinner fa-spin fa-lg"></i>  -->
    <!-- <i class="fa fa-spinner" aria-hidden="true"></i>
    {{message}}
  </h6> -->
  <fa-icon icon="spinner" id="spinner" [size]="size" [spin]="true">{{message}}</fa-icon>
</div>